<template>
	<div class="customer-area-page">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation
						page="billing"
					/>
				</b-col>
				<b-col md="9">
					<h1>Verrechnung</h1>
					<div class="tag-sections">
						<section>
							<template v-if="customer">
								<div v-if="customer.subscription">
									<h2>
										Abonnement:
										<span :class="'ml-1 color-' + getProductColor(customer.subscription.productId)">
											{{ customer.subscription.productLabel }}
										</span>
									</h2>
									<div>
										<b>End-Datum:</b> {{ customer.subscription.endDate | date }}
										<span v-if="followUpProductId">
											| Wechsel auf:
											<span :class="'color-' + getProductColor(followUpProductId)">
												{{ followUpProductLabel }}
											</span>
										</span>
									</div>
									<div><b>Aktiv:</b> {{ customer.subscription.active ? 'ja' : 'nein' }}</div>
									<div v-if="customer.subscription.active">
										<b>Automatische Verlängerung:</b>
										{{ customer.subscription.autoRenew ? 'ja' : 'nein' }}
									</div>
									<div v-if="customer.subscription.active">
										<b>Maximale Kontaktierungen im Vertragszeitraum:</b>
										{{ customer.subscription.possibleContacts || 'unlimitiert' }}
										<span v-if="customer.subscription.possibleContacts && customer.contactingInfo">
											(Bisherige Kontaktierungen: {{ customer.contactingInfo.consumedContacts }})
										</span>
									</div>
									<div class="d-flex align-items-center mt-3">
										<template v-if="customer.subscription.active">
											<Button
												text="Abonnement bearbeiten"
												smaller
												@click="showEditPopUp = true"
											/>
											<Button
												v-if="customer.subscriptionUpgradePossible"
												text="Abonnement upgraden"
												smaller
												class="ml-3"
												@click="showUpgradePopUp = true"
											/>
										</template>
										<template v-else>
											<Button
												text="Abonnement verlängern"
												smaller
												@click="showPurchasePopUp = true"
											/>
										</template>
									</div>
								</div>
								<div v-else>
									<h2>Abonnement</h2>
									<div>Kein aktives Abonnement vorhanden.</div>
									<div class="mt-3">
										<Button
											text="Jetzt abonnieren"
											smaller
											@click="showPurchasePopUp = true"
										/>
									</div>
								</div>
							</template>
						</section>
						<section>
							<h2>Rechnungen</h2>
							<TransactionList
								none-text="Es sind noch keine Rechnungen vorhanden."
							/>
						</section>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<PurchaseSubscriptionPopUp
			v-if="showPurchasePopUp || showUpgradePopUp"
			:is-upgrade="showUpgradePopUp"
			@hidden="onHidePurchasePopUp"
		/>
		<EditSubscriptionPopUp
			v-if="showEditPopUp"
			:subscription="customer.subscription"
			@change="onSubscriptionChange"
			@hidden="showEditPopUp = false"
		/>
	</div>
</template>

<script>
import Navigation from "@/vue/customer-area/Navigation"
import Loading from "@/vue/common/Loading";
import {TOKEN} from "@/helper/transaction/Type";
import TransactionList from "@/vue/transaction/List"
import Button from "@/vue/common/Button";
import Get from "@/api/customer/Get";
import PurchaseSubscriptionPopUp from "@/vue/payment/PurchaseSubscriptionPopUp";
import EditSubscriptionPopUp from "@/vue/payment/EditSubscriptionPopUp";
import {getQueryParams, removeQueryParamsFromUrl} from "@/helper/Url";
import {PRODUCT_COLORS} from "@/helper/product/Product";

export default {

	components: {
		Button,
		Navigation,
		Loading,
		TransactionList,
		PurchaseSubscriptionPopUp,
		EditSubscriptionPopUp
	},

	data ()
	{
		return {
			loadingCustomer: true,
			customer: null,
			transactionTypeToken: TOKEN,
			showPurchasePopUp: false,
			showEditPopUp: false,
			showUpgradePopUp: false,
		};
	},

	async mounted ()
	{
		await this.loadCustomer();

		const queryParams = getQueryParams();

		if (queryParams.openPurchaseSubscriptionPopUp)
		{
			if (this.customer.subscriptionUpgradePossible)
			{
				this.showUpgradePopUp = true;
			}
			else
			{
				this.showPurchasePopUp = true;
			}

			removeQueryParamsFromUrl();
		}
	},

	computed: {
		followUpProductId ()
		{
			return this.customer.subscription.followUpProductId;
		},
		followUpProductLabel ()
		{
			return this.customer.subscription.followUpProductLabel;
		},
	},

	methods: {
		getProductColor (productId)
		{
			return PRODUCT_COLORS[productId];
		},
		onHidePurchasePopUp ()
		{
			this.showPurchasePopUp = false;
			this.showUpgradePopUp = false;
		},
		onSubscriptionChange ()
		{
			this.showEditPopUp = false;
			this.loadCustomer();
		},
		async loadCustomer ()
		{
			this.loadingCustomer = true;

			const response = await new Get().call();

			this.customer = response.data;

			this.loadingCustomer = false;
		}
	}
}
</script>
